import { Spinner } from '@boostbrothers/web-ui/web';
import { type FC, memo } from 'react';

const Loading: FC = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 animate-fade-in">
      <div className="w-12 h-12 animate-scale-in">
        <Spinner colorType="white" />
      </div>
    </div>
  );
};

export default memo(Loading);
